import { render, staticRenderFns } from "./UserKpisComponent.vue?vue&type=template&id=39fa8cca&scoped=true"
import script from "./UserKpisComponent.vue?vue&type=script&lang=js"
export * from "./UserKpisComponent.vue?vue&type=script&lang=js"
import style0 from "./UserKpisComponent.vue?vue&type=style&index=0&id=39fa8cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fa8cca",
  null
  
)

export default component.exports